var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,18 L21,18",
    stroke: "#FF8C42",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,12 L21,12",
    stroke: "#FF8C42",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,6 L21,6",
    stroke: "#FF8C42",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,18 L7,12 L11,15 L15,9 L19,12 L21,9",
    stroke: "#FF8C42",
    strokeWidth: 2,
    fill: "#FF8C42",
    fillOpacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.eb90bcb2a6651095c6a7fc7511640909.svg";
export { ForwardRef as ReactComponent };